import Modal from 'components/Modal'
import ModalBackground from 'components/ModalBackground'
import { useRef } from 'react'
import TermsAndCondition from './TermsAndCondition'

interface ITermsAndConditionsProps {
	onClose: () => void
	show: boolean
}

export function TermsAndConditionModal({ onClose, show }: ITermsAndConditionsProps) {
	const ref = useRef<HTMLDivElement | null>(null)

	return (
		<Modal show={show} className="z-[99] !fixed top-0 right-0 ">
			<ModalBackground show={show} className="!z-0" />
			<div
				className="!z-[99] bg-white max-h-[700px] max-w-[850px] rounded-md mx-3 shadow-lg overflow-hidden "
				ref={ref}
			>
				<TermsAndCondition onClose={onClose} />
			</div>
		</Modal>
	)
}
